import farmerImg from '../assets/image1.png';
import studImg from '../assets/image2.png';
import oldImg from '../assets/image3.png';

export const characters = [
  {
    name: 'Farmer',
    image: farmerImg,
    health: 90,
    community: 75,
    resources: 80,
  },
  {
    name: 'Student',
    image: studImg,
    health: 70,
    community: 85,
    resources: 65,
  },
  {
    name: 'Elder',
    image: oldImg,
    health: 60,
    community: 95,
    resources: 50,
  }
];